module.exports = __webpack_public_path__ + "static/media/comments.bb1258b4.svg";